import {CandidateList} from "./candidateList";
export default CandidateList;
